export const tabs = [
	{ label: 'Utterances', value: 'utterances' },
	{ label: 'Entities', value: 'entities' },
];
